import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HomeActionItem } from '../models/home.models';

@Component({
  standalone: false,
  selector: 'app-home-action-item',
  templateUrl: './home-action-item.component.html',
  styleUrls: ['./home-action-item.component.scss'],
})
export class HomeActionItemComponent {
  @Input({ required: true }) item!: HomeActionItem;

  @Output() navigate = new EventEmitter<HomeActionItem>();

  onNavigate(): void {
    this.navigate.emit(this.item);
  }
}
